import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";

// Mock data for bars - replace them with bars from database
const sampleBars = [
 
];

function ManageBarsPage() {
  const navigate = useNavigate();
  const [bars, setBars] = React.useState(sampleBars);

  const handleDelete = async (id) => {
  const bar = bars.find(b => b.id === id);
  if (!bar) return;

  if (!window.confirm(`Delete bar "${bar.name}"? This will remove its cocktails too.`)) {
    return;
  }

  try {
    const API = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    const res = await fetch(`${API}/bars/${id}`, { method: 'DELETE' });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Delete failed: ${res.status} ${text}`);
    }
    setBars(prev => prev.filter(b => b.id !== id));
    alert('Bar deleted successfully.');
  } catch (err) {
    console.error('Delete bar error:', err);
    alert('Failed to delete bar.');
  }
};

  const handleBack = () => {
    navigate("/admin");
  };

  
useEffect(() => {
  const API = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  (async () => {
    try {
      console.log('Fetching bars from', `${API}/bars`);
      const res = await fetch(`${API}/bars`);
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      const data = await res.json();
      setBars(data);
    } catch (err) {
      console.error('Failed to load bars:', err);
    }
  })();
}, []); 
  
  return (
    <div style={styles.container}>
      {/* Back Button */}
      <button style={styles.back} onClick={handleBack}>←</button>

      <h1 style={styles.title}>Manage Bars</h1>
      <div style={styles.list}>
        {[...bars].sort((a, b) => a.name.localeCompare(b.name)).map((bar) => (
          <div key={bar.id} style={styles.barRow}>
            <span>{bar.name}</span>
            <div>
              <button
                style={styles.editBtn}
                onClick={() => navigate(`/manage-bars/${bar.name}`)}
              >
                Edit
              </button>
              <button
                style={styles.deleteBtn}
                onClick={() => handleDelete(bar.id)}
              >
                ✕
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: blue,
    color: "#fff",
    padding: "40px 20px",
    fontFamily: "'Segoe UI', sans-serif",
    // textAlign: "center",
  },
  title: {
    fontSize: "36px",
    marginBottom: "30px",
    textAlign: "center",
  },
  list: {
    maxWidth: "600px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  barRow: {
    backgroundColor: yellow,
    color: blue,
    padding: "14px 18px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
  },
  editBtn: {
    marginRight: "10px",
    backgroundColor: blue,
    color: yellow,
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  deleteBtn: {
    backgroundColor: "transparent",
    border: "none",
    color: blue,
    fontSize: "20px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  back: {
    alignSelf: "flex-start",
    fontSize: "24px",
    background: "none",
    border: "none",
    color: yellow,
    cursor: "pointer",
    marginBottom: "20px",
  },
};

export default ManageBarsPage;